import { Link } from 'react-router-dom';
import { ReactNode, useCallback, useMemo, useState } from 'react';
import SortRow from './elements/sort-row';
import FilterSidebar from './elements/filter-sidebar';
import Pagination from 'rc-pagination';
import { selectImage } from '../../../util/misc';
import Catalog, { CatalogRenderProps, pageSizes } from '../../catalog';
import { ViewMode } from './catalog-wrapper';

const PaginationItem = (page: number, type: string, element: ReactNode) => {
    switch (type) {
        case 'page': {
            return <div className="ui-pagination-nav__item">{page}</div>;
        }
        case 'prev': {
            return (
                <div className="ui-pagination-nav__item ui-pagination-nav__item--prev">
                    <i className="icon-arrow-left" />
                </div>
            );
        }
        case 'next': {
            return (
                <div className="ui-pagination-nav__item ui-pagination-nav__item--next">
                    <i className="icon-arrow-right" />
                </div>
            );
        }
        case 'jump-prev':
        case 'jump-next': {
            return <div className="ui-pagination-nav__item">...</div>;
        }
    }
    return element;
};

interface CatalogProps {
    viewMode: ViewMode;
    setViewMode: (mode: ViewMode) => void;
    globalMode?: boolean;
}
function NewIekCatalog({ viewMode, setViewMode, globalMode = false }: CatalogProps) {
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const toggleFilter = useCallback(() => setIsFilterOpen((is) => !is), []);
    const render = useMemo(
        () =>
            ({
                query,
                sortBy,
                sortOrder,
                products,
                productsEnd,
                productsStart,
                productsTotal,
                page,
                pageSize,
                classes,
                classId,
                filters,
                filterValues,
                onSortChange,
                setPageSize,
                setPage,
                setQuery,
                setClassId,
                toggleFilterValue,
                resetFilters,
            }: CatalogRenderProps) =>
                (
                    <div className="catalog-content__wrap">
                        <div className="catalog-content__container">
                            {query && (
                                <h2 className="catalog-query-title">
                                    Результаты поиска по запросу «{query}»:
                                </h2>
                            )}
                            <SortRow
                                sortBy={sortBy}
                                sortOrder={sortOrder}
                                onSortChange={onSortChange}
                                viewMode={viewMode}
                                setViewMode={setViewMode}
                                toggleFilter={toggleFilter}
                            />
                            <div className="catalog-items">
                                {products.map(({ name, imageUrl, imageVariants, url, article }) => {
                                    const maxWidth = viewMode === ViewMode.List ? 100 : 200;
                                    const imgUrl = selectImage(imageVariants, maxWidth, 100, imageUrl);
                                    return (
                                        <div key={article} className="catalog-item">
                                            <div className="catalog-item-card">
                                                <Link to={url}>
                                                    <div
                                                        className="catalog-item-card__image"
                                                        style={{
                                                            backgroundImage: imgUrl
                                                                ? `url('${imgUrl}')`
                                                                : 'none',
                                                        }}
                                                    />
                                                </Link>
                                                <div className="catalog-item-card__info">
                                                    <Link to={url} className="catalog-item-card__title">
                                                        {name}
                                                    </Link>
                                                    <div className="catalog-item-card__code">{article}</div>
                                                </div>
                                                <Link to={url} className="catalog-item-card__params">
                                                    Характеристики
                                                </Link>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="ui-pagination">
                                <div className="ui-pagination__text">
                                    Показано {productsStart}-{productsEnd} (всего {productsTotal})
                                </div>
                                <div className="ui-pagination__text ui-pagination__text--right">
                                    Показывать по:&nbsp;
                                    <select
                                        value={pageSize}
                                        onChange={(e) => setPageSize(parseInt(e.target.value))}
                                        className="ui-pagination__size-select"
                                    >
                                        {pageSizes.map((size) => (
                                            <option key={size} value={size}>
                                                {size}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="ui-pagination">
                                <Pagination
                                    className="ui-pagination-nav"
                                    pageSize={pageSize}
                                    current={page}
                                    showLessItems
                                    onChange={(page) => {
                                        document.body.scrollTop = 0;
                                        document.documentElement.scrollTop = 0;
                                        setPage(page);
                                    }}
                                    total={productsTotal}
                                    itemRender={PaginationItem}
                                    showTitle={false}
                                />
                            </div>
                        </div>
                        <FilterSidebar
                            showTitle={viewMode === ViewMode.Tile}
                            showSearch={!globalMode}
                            query={query}
                            setQuery={setQuery}
                            filters={filters}
                            filterValues={filterValues}
                            classes={classes}
                            classId={classId}
                            setClassId={setClassId}
                            toggleFilterValue={toggleFilterValue}
                            resetFilters={resetFilters}
                            isOpen={isFilterOpen}
                            toggleOpen={toggleFilter}
                        />
                    </div>
                ),
        [globalMode, isFilterOpen, setViewMode, toggleFilter, viewMode]
    );
    return <Catalog render={render} />;
}

export default NewIekCatalog;
